<template>
    <!-- 订单控制台的导航栏 -->

    <el-menu menu-trigger="click" class="nav-order" mode="horizontal">
        <el-menu-item @click="toOrderHome()" style="margin-left: 250px" index="order_home">订单控制台</el-menu-item>
        <el-menu-item @click="toOrderVerify()" index="order_verify">审核控制台</el-menu-item>
        <el-menu-item class="stereo-class" @click="toOrderStereo()" index="order_stereo">版房控制台</el-menu-item>
        <el-menu-item @click="toOrderApply()" index="orderApply">采购控制台</el-menu-item>
        <el-submenu class="nav-order" index="produce">
            <template slot="title">生产进度</template>
            <el-menu-item @click="toPro()" index="pro">生产控制台</el-menu-item>
            <el-menu-item @click="toCuttingWorkSpace()" index="pro_1">裁床控制台</el-menu-item>
            <el-menu-item @click="toSewWorkSpace()" index="2-3">缝纫控制台</el-menu-item>
            <el-menu-item @click="toVendorWorkSpace()" index="2-4">外协控制台</el-menu-item>
            <el-menu-item @click="toEndHandleWorkSpace()" index="2-5">后道控制台</el-menu-item>
        </el-submenu>
        <el-menu-item @click="toOrderInStore()" index="orderInStore">入库控制台</el-menu-item>
        <el-submenu class="nav-order" index="finance">
            <template slot="title">财务</template>
            <el-menu-item @click="toGroupOrderFinance()" index="groupOrderFinance">小组分派单</el-menu-item>
            <el-menu-item :disabled="true" index="groupInfoFinance">小组结算(开发中...)</el-menu-item>
            <el-menu-item :disabled="true" index="factoryInfoFinance">工厂结算(开发中...)</el-menu-item>
        </el-submenu>
        <el-menu-item class="setup-class" @click="toOrderSetup()" index="orderSetup">配置</el-menu-item>
        <el-menu-item v-if="toProRequirementPower" @click="toProRequirement()" index="toProRequirement">开发需求管理</el-menu-item>
    </el-menu>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "OrderBar",
        computed: {

            /**
             * 进入产品开发文档的权限
             */
            toProRequirementPower() {
                return new Set([1, 11]).has(this.userId)
            },

            /**
             * 当前用户的 userId
             * @returns {string}
             */
            userId() {
                return this.currentUserInfo.id
            },
            ...mapState(['currentUserInfo'])
        },
        methods: {
            toOrderHome() {
                const routerName = 'order_home' // 跳转的路由 router 名称
                this.toRouter(routerName)

            },

            // 版房通知台
            toOrderStereo() {
                const routerName = 'order_stereo' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },

            toOrderVerify() {
                const routerName = 'order_verify' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },
            toPro() {
                const routerName = 'orderPro' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },
            toCuttingWorkSpace() {
                const routerName = 'cuttingWorkSpace' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },
            toSewWorkSpace() {
                const routerName = 'sewWorkSpace' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },
            toVendorWorkSpace() {
                const routerName = 'vendorWorkSpace' // 跳转的路由 router 名称
                this.toRouter(routerName)
            },
            toEndHandleWorkSpace() {
                const routerName = 'endHandleWorkSpace'
                this.toRouter(routerName)
            },
            toOrderInStore() {
                const routerName = 'orderInStore'
                this.toRouter(routerName)
            },
            toOrderApply() {
                const routerName = 'orderApply'
                this.toRouter(routerName)
            },
            toOrderSetup() {
                const routerName = 'orderSetup'
                this.toRouter(routerName)
                // window.location.href = "/order_platform/setup/";
            },
            toProRequirement() {
                const routerName = 'proRequirement'
                this.toRouter(routerName)
            },
            toGroupOrderFinance(){
                const routerName = 'groupOrderFinance'
                this.toRouter(routerName)
            },
            toGroupInfoFinance(){
                const routerName = 'groupInfoFinance'
                this.toRouter(routerName)
            },
            toFactoryInfoFinance(){
                const routerName = 'factoryInfoFinance'
                this.toRouter(routerName)
            },
            toRouter(routerName) {
                this.$router.replace({name: routerName})
            },
        },
    }
</script>

<style scoped>
    .nav-order {
        height: 30px;
        line-height: 30px;
    }

    .nav-order .el-menu-item {
        height: 30px;
        line-height: 30px;
        font-size: 13px;
    }

    .nav-order >>> .el-submenu__title {
        height: 30px !important;
        line-height: 30px !important;
    }

</style>
